import { useState } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Box from '@mui/material/Box';

function InfoAlerts({ heading, message, buttonName = '' }) {
  const [show, setShow] = useState(false);

  return (
    <Box sx={{ width: show ? '100%' : 'auto', flexBasis: show ? '100%' : 'auto', mb: show ? 2 : 0 }}>
      <Collapse in={show} unmountOnExit>
        <Alert
          severity="info"
          onClose={() => setShow(false)}
          sx={{ mb: 2 }}
        >
          <AlertTitle>{heading}</AlertTitle>
          {message}
        </Alert>
      </Collapse>
      {!show && (
        <Button variant="outlined" color="info" onClick={() => setShow(true)}>
          {buttonName}
        </Button>
      )}
    </Box>
  );
}

export default InfoAlerts;